<div [style.width]="width" class="element-wrapper">
  <span class="icon">
    <app-tooltip-icon
      *ngIf="!!infoTranslationKey"
      [translationKey]="infoTranslationKey"
    ></app-tooltip-icon>
  </span>
  <ng-content></ng-content>
</div>
